import type { FaireProductEntity } from "../../entity_types/product";

export const p_dckjo17pos: FaireProductEntity = {
  token: "p_dckjo17pos",
  type: "product",
  name: "Women's Organic Cotton Bathrobe & Spa Robe",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/328514a886a78b1d299baeca691c11c7a5bd4540d1acdde926c34715571318ba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd1ee994270810ce3f51c03085f1d0f43df7dbcb12299300f2f57896cf5c4a10.jpeg",
    "https://cdn.faire.com/fastly/31f433282a9947307874c97d559adfb1b5f3e5949ea945d35ef7664fce1055af.jpeg",
    "https://cdn.faire.com/fastly/ec4d31f937583ad4b996265e82d0e141523dec195f1a47911f9d51e0f8d76822.jpeg",
    "https://cdn.faire.com/fastly/c8daa6280ecfd4ebe190eea2b9741f8dd484bbcbf7e3126498528a8f79f66cf4.jpeg",
    "https://cdn.faire.com/fastly/d7071419dd20608777b9a1c7f590ec8c9bf535dc6d7f520970c8e112c08c87e8.jpeg",
    "https://cdn.faire.com/fastly/4f7abe32d120953ae2ce783ee374bc053056ebdd18f776670ff672d630ae74d3.jpeg",
    "https://cdn.faire.com/fastly/76b54709e8e2159b9c47a3db9f3cf612280e0c78a5a128dbc0cab2b1f8aff39d.jpeg",
    "https://cdn.faire.com/fastly/a5eed21bbfb9db372fa59c3ac4ddeb15eab3ec3c92a749c3c13fb8697e9c10c9.jpeg",
    "https://cdn.faire.com/fastly/0e574bfbc795e8241273d7fef6a6110df43780196d0d2358df43ccf54852eea6.jpeg",
  ],
  priceDollars: 35,
  description:
    "Luxurious 100% organic cotton interlock bath & spa robe, experience 'pure comfort'.\nNaturally stretchy and super soft organic interlock cotton for added comfort.\nFeaturing a Relaxed & comfy universal fit with sewn-in waist belt, 2 front pockets, hanging loop & tagless.\nSuper soft, cozy, comfortable, All-season.\nLightweight & travel friendly, easy to maintain & machine washable.\nNon-toxic, eco-friendly & sustainable.\nMaternity Friendly - perfect for during & after pregnancy.\nIdeal robe for bridal party, bridal getting ready parties & corporate gifting programs.\nEthically produced at a GOTS & fairtrade certified facility in India.",
  tags: [],
  msrpDollars: 70,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:27.946Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
